export default {
  perBooking: 'Per Booking',
  perPerson: 'Per Person',
  perNight: 'Per Night',
  perPersonPerNight: 'Per Person Per Night',
  perAccommodationProduct: 'Per Room',
};
